/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from 'react'
import { Outlet, Link } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../_metronic/helpers'

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  return (
    <div className='flex-container'>
      <div style={{ width: '40%' }} className='d-flex flex-center flex-row-fluid order-2 order-lg-1 p-10'
      >
        <Outlet />
      </div>
      {/* <div
        className='d-none d-lg-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2'
        style={{ filter: 'brightness(0.8)', height: '100%' }}
      > */}
      <div id="kt_carousel_1_carousel"
        className="carousel carousel-custom slide d-none d-lg-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2"
        data-bs-ride="carousel"
        data-bs-interval="3000"
      >
        <div className="carousel-inner">
          <img className='w-100 carousel-item active' src={toAbsoluteUrl('/media/pgn/auth-pgn-bg.jpeg')} style={{ objectFit: 'cover', height: '100%' }} alt="" />
          <img className='w-100 carousel-item' src={toAbsoluteUrl('/media/pgn/auth-pgn-bg-2.jpg')} style={{ objectFit: 'cover', height: '100%' }} alt="" />
          <img className='w-100 carousel-item' src={toAbsoluteUrl('/media/pgn/auth-pgn-bg-3.jpg')} style={{ objectFit: 'cover', height: '100%' }} alt="" />
        </div>
        <div style={{ bottom: 0 }} className="position-absolute d-flex justify-content-center w-100">
          <div className='d-flex align-items-center justify-content-center flex-wrap'>
            <ol className="p-0 m-0 carousel-indicators carousel-indicators-dots">
              <li
                data-bs-target="#kt_carousel_1_carousel"
                data-bs-slide-to="0"
                className="ms-1 active"
              ></li>
              <li
                data-bs-target="#kt_carousel_1_carousel"
                data-bs-slide-to="1"
                className="ms-1"
              ></li>
              <li
                data-bs-target="#kt_carousel_1_carousel"
                data-bs-slide-to="2"
                className="ms-1"
              ></li>
            </ol>
          </div>
        </div>
      </div>
      {/* <img className='w-100' src={toAbsoluteUrl('/media/misc/auth-pgn-bg.jpeg')} style={{ objectFit: 'cover' }} alt="" /> */}
      {/* </div> */}
    </div>
  )
}

export { AuthLayout }
